<div class="modal-header" appCustomAutofocus>
    <h3>{{ headerText }}</h3>
</div>
<div class="modal-body">
    <p [innerHTML]="bodyText"></p>
</div>
<div class="modal-footer">
    <button type="button" class="btn" (click)="saveAndCloseModal()"
            [ngClass]="{'btn-danger': (warningLevel == null || warningLevel === 'danger'), 'btn-primary': warningLevel === 'primary', 'btn-success': warningLevel === 'success'}">
    {{ confirmButtonText }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="closeModal()">{{ cancelButtonText }}</button>
</div>